import type { CatalogBrandItemDTO, PlatformBrandDTO, PutPlatformBrandResponseDTO } from '@today/types'
import { apiClient } from './api.client'

/** The runtime platform-brand pointer (TO-541): its public read, the catalogue and the super-admin switch. */
export const platformBrandService = {
	/** `GET /platform/brand` — public; the id the platform surfaces bind. */
	async get(): Promise<PlatformBrandDTO> {
		const { data } = await apiClient.get<PlatformBrandDTO>('/platform/brand')
		return data
	},

	/** `GET /admin/brands` — Super-Admin; the brands the switcher offers. */
	async listCatalog(): Promise<CatalogBrandItemDTO[]> {
		const { data } = await apiClient.get<{ items: CatalogBrandItemDTO[] }>('/admin/brands')
		return data.items
	},

	/** `PUT /admin/platform/brand` — Super-Admin; switch the pointer. */
	async put(brandId: string): Promise<PutPlatformBrandResponseDTO> {
		const { data } = await apiClient.put<PutPlatformBrandResponseDTO>('/admin/platform/brand', { brandId })
		return data
	},
}
